import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';

import {Observable} from 'rxjs';
import {AppUser} from '../AppUser';
import {Cast} from '../cast';

@Injectable()
export class FrameworkHttpService {

	constructor(public http: HttpClient, public appUser: AppUser) {
	}

	getHeaders(): HttpHeaders {
		return new HttpHeaders({
			'Content-Type': 'application/json',
			Authorization: 'Bearer ' + this.appUser.getToken()
		});
	}


	public forbidden() {
		alert('You are not allowed access to this page');
		document.location.replace('/');
	}

	public loginHasExpired() {
		alert('You are not allowed to access this resource or your authentication has expired, you will now be redirect to login');
		window.location.href = '/';
		document.location.reload();
	}

	public GET(url, returnedClass, asArray = true, cb401?: () => void, cb409?: () => void): Promise<any> {
		return new Promise<any>((ok, err) => {
			this._get(url).toPromise().then(r => {
				if (!returnedClass) {
					ok(r);
				} else {
					ok(asArray ? Cast.array(r, returnedClass) : Cast.instance(r, returnedClass));
				}
			}, e => {
				console.log('ERRROR HANLDING', cb401);
				if (e.status === 401) {
					if (cb401) {
						cb401.call(this);
					} else {
						return this.loginHasExpired();
					}
				}
				if (e.status === 409) {
					if (e.status === 409) {
						if (cb409) {
							cb409.call(this);
						} else {
							return this.forbidden();
						}
					}
				}
				err(e);
			});
		});
	}

	public POST(url, data, returnedClass, asArray = true, cb401?: () => void, cb409?: () => void): Promise<any> {
		return new Promise<any>((ok, err) => {
			this._post(url, data).toPromise().then(r => {
				if (!returnedClass) {
					ok(r);
				} else {
					ok(asArray ? Cast.array(r, returnedClass) : Cast.instance(r, returnedClass));
				}
			}, e => {
				if (e.status === 401) {
					if (cb401) {
						cb401.call(this);
					} else {
						return this.loginHasExpired();
					}
				} else if (e.status === 409) {
					if (cb409) {
						cb409.call(this);
					} else {
						return this.forbidden();
					}
				} else {
					err(e);
				}
			});
		});
	}

	public PUT(url, data, returnedClass, asArray = true): Promise<any> {
		return new Promise<any>((ok, err) => {
			this._put(url, data).toPromise().then(r => {
				if (!returnedClass) {
					ok(r);
				} else {
					ok(asArray ? Cast.array(r, returnedClass) : Cast.instance(r, returnedClass));
				}
			}, e => {
				if (e.status === 401) {
					return this.loginHasExpired();
				}
				if (e.status === 409) {
					return this.forbidden();
				}
				err(e);
			});
		});
	}

	public DELETE(url, returnedClass, asArray = true): Promise<any> {
		return new Promise<any>((ok, err) => {
			this._delete(url).toPromise().then(r => {
				if (!returnedClass) {
					ok(r);
				} else {
					ok(asArray ? Cast.array(r, returnedClass) : Cast.instance(r, returnedClass));
				}
			}, e => {
				if (e.status === 401) {
					return this.loginHasExpired();
				}
				if (e.status === 409) {
					return this.forbidden();
				}
				err(e);
			});
		});
	}

	protected _get(url): Observable<any> {
		return this.http
			.get(url, {headers: this.getHeaders()});
	}

	protected _post(url, data): Observable<any> {
		return this.http
			.post(url, data, {headers: this.getHeaders()});
	}

	protected _put(url, data): Observable<any> {
		return this.http
			.put(url, data, {headers: this.getHeaders()});
	}

	protected _delete(url) {
		return this.http
			.delete(url, {headers: this.getHeaders()});
	}
}
